interface CompressImageOptions {
    maxDimension?: number;
    quality?: number;
    skipBelowBytes?: number;
}

export async function compressImage(file: File, options: CompressImageOptions = {}): Promise<File> {
    const { maxDimension = 1920, quality = 0.85, skipBelowBytes = 500 * 1024 } = options;

    if (!file.type.startsWith('image/')) {
        return file;
    }

    // already small enough — skip re-encoding
    if (file.size <= skipBelowBytes) {
        return file;
    }

    try {
        const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
        const scale = Math.min(1, maxDimension / Math.max(bitmap.width, bitmap.height));
        const targetWidth = Math.round(bitmap.width * scale);
        const targetHeight = Math.round(bitmap.height * scale);

        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            bitmap.close();
            return file;
        }
        ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight);
        bitmap.close();

        const blob = await new Promise<Blob | null>((resolve) => {
            canvas.toBlob(resolve, 'image/jpeg', quality);
        });

        if (!blob || blob.size >= file.size) {
            return file;
        }
        return new File([blob], file.name, { type: 'image/jpeg' });
    } catch (err) {
        console.warn('Image compression failed, using original', err);
        return file;
    }
}
